import React, { useCallback } from 'react';

import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from 'react-icons/fa';
import { IoMailOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';

import { StyledMainMenu } from './styles';
import { useAuth } from '../../../hooks/use-auth';
import { useMainNavItems } from '../../../hooks/use-main-nav-items';
import { Paragraph1, TextLink1, TextLink2, variables } from '../../../theme';
import SingleLogo from '../../../theme/assets/logo/logo-vertical-v3.webp';
import { bemClassName } from '../../../utils/bem';
import { SUPPORT_EMAIL } from '../../../utils/constants';
import { GradientButton } from '../../molecules/gradient-button';
import { HorizontalMenu } from '../../molecules/horizontal-menu';
import { UserMenu } from '../user-menu';

const b = bemClassName('main-menu');

const MainMenu = () => {
  const navigate = useNavigate();

  const { isAuthenticated } = useAuth();
  const navItems = useMainNavItems();

  const goToHome = useCallback(() => {
    navigate('/');
  }, [navigate]);

  const goToOnboarding = useCallback(() => {
    navigate('/onboarding');
  }, [navigate]);

  return (
    <StyledMainMenu>
      <div className={b()}>
        <div className={b('logo-container')}>
          <img src={SingleLogo} alt="Active Shape" onClick={goToHome} />
        </div>
        <div className={b('center-section')}>
          <div className={b('center-section', 'top')}>
            <div className={b('center-section', 'top', 'contact')}>
              <TextLink1>
                <IoMailOutline />
                {SUPPORT_EMAIL}
              </TextLink1>
            </div>
            <div className={b('center-section', 'top', 'social')}>
              <Paragraph1>Visit our social pages:</Paragraph1>
              <div className={b('center-section', 'top', 'social', 'links')}>
                <TextLink2>
                  <FaFacebook />
                </TextLink2>
                <TextLink2>
                  <FaTwitter />
                </TextLink2>
                <TextLink2>
                  <FaLinkedin />
                </TextLink2>
                <TextLink2>
                  <FaInstagram />
                </TextLink2>
              </div>
            </div>
          </div>
          <div className={b('center-section', 'bottom')}>
            <div className={b('right')}>
              <HorizontalMenu items={navItems.map(({ key, label, link }) => ({ key, label, link }))} />
            </div>
          </div>
        </div>
        <div className={b('right-section')}>
          {isAuthenticated ? (
            <UserMenu backgroundColor={variables.colors.white} />
          ) : (
            <GradientButton onClick={goToOnboarding}>SIGN UP</GradientButton>
          )}
        </div>
      </div>
    </StyledMainMenu>
  );
};

export default MainMenu;
